// extracted by mini-css-extract-plugin
module.exports = {"heading":"Point-module--heading--3ev2x","container":"Point-module--container--2Frch"};